import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftLogServer } from "namirasoft-log";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { LogLayout } from "./LogLayout";
import { LogRoutes } from "./LogRoutes";
import HomePage from "./pages/HomePage";
import LogGroupEditPage from "./pages/LogGroupEditPage";
import LogGroupListPage from "./pages/LogGroupListPage";
import LogGroupViewPage from "./pages/LogGroupViewPage";
import LogListPage from "./pages/LogListPage";
import LoginPage from "./pages/LoginPage";
import UsagePage from "./pages/UsagePage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_LOG}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_LOG = new EnvService("REACT_APP_BASE_URL_LOG", true).getString();

            let log = new NamirasoftLogServer(REACT_APP_BASE_URL_LOG, result.account.token_manager, result.notifier.onError);

            let servers = { log };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={LogRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={LogRoutes.LogList(":log_group_id")} element={<LogListPage {...result} servers={servers} />} />

                            <Route path={LogRoutes.LogGroupList} element={<LogGroupListPage {...result} servers={servers} />} />
                            <Route path={LogRoutes.LogGroupNew} element={<LogGroupEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={LogRoutes.LogGroupView(":id")} element={<LogGroupViewPage {...result} servers={servers} />} />
                            <Route path={LogRoutes.LogGroupEdit(":id")} element={<LogGroupEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={LogRoutes.LogGroupCopy(":id")} element={<LogGroupEditPage {...result} servers={servers} isEdit={false} />} />

                            <Route path={LogRoutes.Usage} element={<UsagePage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={LogRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <LogLayout {...props}>
                {props.children}
            </LogLayout>
        )}
        requirement={{
            verification: {
                email: true,
                phone: false
            }
        }}
    />
}

export default Router;